import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, LoadingController, ModalController, AlertController } from '@ionic/angular';
import { SortType } from '@swimlane/ngx-datatable';
import { AddClassComponent } from 'src/app/components/add-class/add-class.component';
import { AlertService } from 'src/app/services/alert.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-classes',
  templateUrl: './classes.page.html',
  styleUrls: ['./classes.page.scss'],
})
export class ClassesPage implements OnInit {
  classes  = [];
  classesUnfiltered = [];
  multiSort = SortType.multi;

  searchName;
  isLoading: boolean = true;
  constructor(
    private menuCtrl: MenuController,
    private loadingCtrl: LoadingController,
    private router: Router,
    private modalCtrl: ModalController,
    private fireStoreService : FirestoreService,
    private alertController : AlertController,
    private toastService : ToastService,
    private alertService :AlertService

  ) {}

  
  ionViewWillEnter() {
    this.menuCtrl.enable(true);
    this.classes = [...this.classes];
  }



  ngOnInit() {
    // this.addNew();
    // return;
    this.loadingCtrl.create({ keyboardClose: true }).then((loadingEl) => {
      loadingEl.present();
      this.fireStoreService.getCollection(this.fireStoreService.CLASSES).subscribe(
        (res) => {
          this.isLoading = false;
          console.log(res);
          this.classes = res;
          this.classesUnfiltered = this.classes;
          loadingEl.dismiss();
        },
        (err) => {
          this.isLoading = false;
          loadingEl.dismiss();
        }
      );
    });
  }

  async deleteClass(classId) {
    const alert = await this.alertController.create({
      header: 'Alert',
      message:
        'Are you sure you want to delete this class? This action cannot be undone',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: (blah) => {},
          cssClass: 'alert-btn',
        },
        {
          text: 'Yes',
          cssClass: 'alert-btn',
          handler: () => {
            this.loadingCtrl.create().then((loadingEl) => {
              loadingEl.present();

              this.fireStoreService
                .deleteDocument(this.fireStoreService.CLASSES, classId)
                .subscribe(
                  (res) => {
                    loadingEl.dismiss();
                    this.toastService.presentToast('Class deleted');
                  },
                  (err) => {
                    loadingEl.dismiss();
                    this.alertService.showFirebaseAlert(err);
                  }
                );
            });
          },
        },
      ],
    });
    await alert.present();
  }


  async addNew() {
    this.router.navigate([`/add-class`]);
    // const modal = await this.modalCtrl.create({
    //   component: AddClassComponent,
    //   cssClass: 'custom-modal',
    //   backdropDismiss : false
    // });

    // return await modal.present().catch((err) => {
    //   console.log(err);
    // });
  }



  onActivate(event) {
    // if (event.type == 'click') {
    //   this.router.navigate(['/class-details'], {queryParams : {id :event.row.id}})
    // }
  }



  search() {
    this.resetChanges();
    if (!(this.searchName === '')) {
      const searchResult = this.classes.filter((currentList) => {
        if (currentList.name && this.searchName) {
          return (
            currentList.name
              .toLowerCase()
              .indexOf(this.searchName.toLowerCase()) > -1
          );
        }
      });
      this.classes = searchResult;
    }
  }

  resetChanges() {
    this.classes = this.classesUnfiltered;
  }

  async edit(row) {
    console.log(row);
    
    this.router.navigate([`/add-class`], {
      queryParams: { isEditing: true, id: row.id, data: JSON.stringify(row) },
    });
    // const modal = await this.modalCtrl.create({
    //   component: AddClassComponent,
    //   componentProps : {
    //     data : row,
    //     isEditing : true
    //   },
    //   cssClass: 'custom-modal',
    //   backdropDismiss : false
    // });

    // return await modal.present().catch((err) => {
    //   console.log(err);
    // });
  }

}
